import Team from "../../../model2/team/team"
import {AddTeam_Manager} from "./manager"
import Workspace from "../../../model2/space/workspaces/workspace"
import ProjectSession from "../../../model2/project/project-session"
import Task from "../../../model2/task/task"
import Collection from "../../../data-structures/collection"
import {TeamToAdd} from "./add-team"
import {ProjectAccess} from "../../../gd/const/project"

// const debug = "TeamsToAdd"
const debug = false

export default class TeamsToAdd extends Collection<TeamToAdd> {

    public manager  : AddTeam_Manager
    private defaultWorkspaceAccess  : ProjectAccess = ProjectAccess.STANDARD
    private defaultProjectAccess    : ProjectAccess = ProjectAccess.STANDARD

    constructor(manager: AddTeam_Manager, models: TeamToAdd[] = []) {
        super(models)

        this.manager = manager
    }

    get atLeastOneChecked(): boolean {
        const firstChecked = _.find(this.models, (teamToAdd: TeamToAdd) => {
            return teamToAdd.isSelected
        })

        return !!firstChecked;
    }

    get selected(): TeamToAdd[] {
        return _.filter(this.models, (teamToAdd)=>{
            return teamToAdd.isSelected
        })
    }

    unselectAll() {
        _.map(this.models, (teamToAdd: TeamToAdd) => {
            return teamToAdd.unselect()
        })
    }

    resetForWorkspace(workspace: Workspace, task?: Task) {
        debug && console.log(debug, "resetForWorkspace", workspace.id)

        // 1. collect all workspace and task (if any) existing users
        let existingTeamIds : ID[] = workspace.project.teamIds()
        if (task) existingTeamIds = _.union(existingTeamIds, task.teamIds)

        const models : TeamToAdd[] = []

        // 2. find company teams which are not in this workspace yet
        const notInWorkspace : Team[] = _.filter(gd.session.teams.models, (team:Team)=>{
            return !existingTeamIds.includes(team.id)
        })

        _.map(notInWorkspace, (team: Team) => {
            const teamToAdd = new TeamToAdd(team)
            teamToAdd.workspaceAccess   = this.defaultWorkspaceAccess   // we need default access
            teamToAdd.projectAccess     = this.defaultProjectAccess     // we need default access
            models.push(teamToAdd)
        })

        this.reset(models)
    }

    resetForProjectInWorkspace(workspace: Workspace, project: ProjectSession, task?: Task) {
        debug && console.log(debug, "resetForProjectInWorkspace", workspace.id, project.id, task?.id)

        const models : TeamToAdd[] = []

        // 1. collect all project and task (if any) existing users
        let existingTeamIds : ID[] = project.teamIds()
        if (task) existingTeamIds = _.union(existingTeamIds, task.teamIds)

        // 2. find company teams which are not customers and not in this workspace yet
        const notInWorkspace : ID[] = _.filter(workspace.project.teamIds(), (TeamId:ID)=>{
            return !existingTeamIds.includes(TeamId)
        })

        _.map(notInWorkspace, (teamId: ID) => {
            const team = gd.session.teams.get(teamId)!

            const teamToAdd = new TeamToAdd(team)

            let minUserAccess
            _.map(team.userIds, (userId: ID) => {
                const projectUser = gd.session.projectUsers.findByProjectAndUser(workspace.project.id, userId)
                minUserAccess = projectUser?.access
            })

            // workspaceAccess is required to know for min project access in INHERITANCE_CHILDREN mode
            teamToAdd.workspaceAccess   = minUserAccess

            // project access can't be lower than workspace access if any
            if (teamToAdd.workspaceAccess && this.defaultProjectAccess < teamToAdd.workspaceAccess) {
                teamToAdd.projectAccess     = teamToAdd.workspaceAccess
            } else {
                teamToAdd.projectAccess     = this.defaultProjectAccess
            }

            models.push(teamToAdd)
        })

        this.reset(models)
    }

    resetForProjectWithoutWorkspace(project: ProjectSession, task?: Task) {
        debug && console.log(debug, "resetForProjectWithoutWorkspace", project.id, task?.id)

        const models : TeamToAdd[] = []

        // 1. collect all project and task (if any) existing users
        let existingTeamIds : ID[] = project.teamIds()
        if (task) existingTeamIds = _.union(existingTeamIds, task.teamIds)

        // 2. find company users who are not customers and not in this workspace yet
        const notInProject : Team[] = _.filter(gd.session.teams.models, (team:Team)=>{
            return !existingTeamIds.includes(team.id)
        })

        _.map(notInProject, (team: Team) => {
            const teamToAdd         = new TeamToAdd(team)
            teamToAdd.projectAccess = ProjectAccess.STANDARD
            models.push(teamToAdd)
        })

        this.reset(models)
    }

    resetForTask(task: Task) {
        debug && console.log(debug, "resetForTask", task.id)

        const models : TeamToAdd[] = []

        // 1. find all task user ids
        const existingTeamIds : ID[] = task.teamIds

        // 2. find project users who have access at least LIMITED and are not in this task yet
        const notInProject : ID[] = _.filter(task.project?.teamIds(), (teamId:ID)=>{
            return !existingTeamIds.includes(teamId)
        })

        _.map(notInProject, (teamId: ID) => {
            const team = gd.session.teams.get(teamId)!

            const teamToAdd = new TeamToAdd(team)
            models.push(teamToAdd)
        })

        this.reset(models)
    }

    get hasAvailable() {
        return !_.isEmpty(this.available)
    }

    get available():TeamToAdd[] {
        let models : TeamToAdd[] = this.models

        if (this.manager.searchEnabled) {
            return _.filter(models, (teamToAdd: TeamToAdd)=>{
                return teamToAdd.team.quickSearch(this.manager.searchPrompt)
            })
        }

        return models
    }
} 